module.exports = __webpack_public_path__ + "static/img/050402.fb813d05.png";